import React, { useState } from 'react';
import { TextInput } from '@pwc/pwc-deals-ui';

const ScoreTextInput = ({ category, onScoreChange }) => {
  const [error, setError] = useState('');
  const errorMessage = 'Invalid value. Enter a number between 1 and 10.';

  return (
    <TextInput
      type="number"
      error={error}
      field={{
        name: `${category.categoryId}`,
        value: `${category.value}`,
        onChange: (event) => {
          const newValue = +event.target.value;
          if (newValue < 0 || newValue > 10) {
            setError(errorMessage);
          } else {
            setError('');
          }
          onScoreChange(newValue);
        },
      }}
    />
  );
};

export default ScoreTextInput;
